"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.first = void 0;
const first = (root) => {
    let curr = root;
    while (curr)
        if (curr.l)
            curr = curr.l;
        else
            return curr;
    return curr;
};
exports.first = first;
